// removed by extract-text-webpack-plugin
module.exports = {"container":"oVbceCHDsOJpM-rhZcdb6","link":"_3BptJo2G6u4-gQRS8BmfVw","BUColor":"Va1eq0Jm2N2ghV7DaKYtc"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Footer/styles.css
// module id = 1476
// module chunks = 0